import { Link } from "@fluentui/react";
import React from "react";

const PowerAppSolutionEnvs = ({environments}) => {

    const PowerAppSolutionEnv = ({environment}) => {
        const envContainerStyles = {
            display: 'flex'
        }

        return (
            <div style={envContainerStyles}>
                <div><Link href={`${environment.solutionsUrl}/${environment.parentSolutionInternalId}`} target='_blank'>{environment.name}</Link></div>
            </div>
        )
    }

    return (
        <div style={containerStyles}>
            <label style={labelStyles}>Exists on environments:</label>
            <div style={allEnvsContainerStyles}>
                {environments.map(e => <PowerAppSolutionEnv key={e.id} environment={e} />)}
            </div>
        </div>
    )
}

const allEnvsContainerStyles = {
    marginTop: 5
}

const containerStyles = {
    marginTop: 16,
    padding: 10,
    height: 81,
    border: '1px solid rgb(138, 136, 134)',
    overflow: 'auto'
}

const labelStyles = {
    fontWeight: 600
}

export default PowerAppSolutionEnvs


// WEBPACK FOOTER //
// ./src/components/ManageCenter/PowerAppSolutionEnvs.js